import PropTypes from 'prop-types';

//////////////////////////////////////////////////////////////////////////////////////////
// Misc shapes
//////////////////////////////////////////////////////////////////////////////////////////
export interface AuthErrorInfo {
    response: any;
    errorCode: string;
    errorMessage: string | null;
    exceptionType: string | null;
    exceptionData: string | null;
}

export class AuthError extends Error {
    public authErrorInfo: AuthErrorInfo;

    constructor(authErrorInfo: AuthErrorInfo, ...params: any[]) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(...params);

        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AuthError);
        }

        if (authErrorInfo.errorMessage !== null) {
            this.message = authErrorInfo.errorMessage;
        }
        // Custom debugging information
        this.authErrorInfo = authErrorInfo;
    }
}

// export interface SignupEmailExistValidate {
//     readonly data: boolean;
// }

export interface TokenSet {
    accessToken: string;
}

export interface TokenSetWithExpire {
    accessToken: string;
    expiresAt: string;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Redux state shapes
//////////////////////////////////////////////////////////////////////////////////////////
export interface AuthState {
    readonly isAuthenticating: boolean;
    readonly isAuthenticated: boolean;
    readonly isCreatingNewUser: boolean;
    readonly isObtainingNewAccessToken: boolean;
    readonly accessToken: string | null;
    readonly errorCode: string | null;
    readonly errorMessage: string | null;
    readonly exceptionType: string | null;
    readonly exceptionData: string | null;
}

//////////////////////////////////////////////////////////////////////////////////////////
// Action Prop Types shapes
//////////////////////////////////////////////////////////////////////////////////////////
export const ActionPropTypes = PropTypes.shape({
    loginUserRequest: PropTypes.func.isRequired,
    loginUserSuccess: PropTypes.func.isRequired,
    loginUserFailure: PropTypes.func.isRequired,
    logoutUserSuccess: PropTypes.func.isRequired,
    getnewAccessTokenRequest: PropTypes.func.isRequired,
    getnewAccessTokenSuccess: PropTypes.func.isRequired,
    getnewAccessTokenFailure: PropTypes.func.isRequired,
}).isRequired;

//////////////////////////////////////////////////////////////////////////////////////////
// Api response shapes
//////////////////////////////////////////////////////////////////////////////////////////
